import React from 'react'

/** Context for the current theme. */
export const ThemeContext = React.createContext('dark')

/** Makes a component subscribe to theme changes, and passes on the 'theme' prop. */
export const acpTheme = () => Component => {
  return props => <ThemeContext.Consumer>{theme => <Component {...props} theme={theme} />}</ThemeContext.Consumer>
}
